import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from 'axios'
import { endpoints } from "../../../endpoints";


export const allEarnings = createAsyncThunk("allEarnings/getList" , async (payload , Thunk) =>{
    try {
        const response = await axios.post(endpoints.earnings.getAllEarnings , payload)
        return response.data;
    }
    catch(err){
        return Thunk.rejectWithValue(err)
    }
})

